import { Button, Col, DatePicker, Dropdown, Form, Input, Row, Select, Tooltip } from 'antd';
import { useState, useEffect, useCallback } from 'react';
import ActionsComponent from 'src/components/shared/ActionsComponent';
import GridLayout from 'src/components/shared/gridLayout';
const Filters = (props) => {
    const { RangePicker } = DatePicker;
    const [open, setOpen] = useState(false);
    const [form] = Form.useForm()
    useEffect(() => {
        form.setFieldsValue(props?.filterValues);
        if (props?.onloadGrid) {
            props.onloadGrid();
        }
    }, [props?.filterValues])
    const handleSearch = useCallback((values) => {
        const trimmedValues = {
            ...values,
            cardNumber: values?.cardNumber?.trim(),
            email: values?.email?.trim()
        };
        setOpen(false);
        props?.filterObj(trimmedValues);
    }, [props])
    const handleOpenChange = useCallback((nextOpen, info) => {
        if (info.source === 'trigger' || nextOpen) {
            setOpen(nextOpen);
        }
    }, [])
    const handleMenuClick = (e) => {
        if (e.key === '3') {
            setOpen(false);
        }
    };
    const clearRecords = useCallback(() => {
        props?.filterObj({ "cardType": null, cardStatus: null, startDate: null, endDate: null });
        form.resetFields()
    }, [props, form])
    const handleChange = useCallback((e) => {
        const trimmedValue = e.target.value.replace(/\s+/g, '');
        form.setFieldsValue({ email: trimmedValue });
    }, [form])
    const items = [
        {
            label:
                <Form className="grid-filter-form"
                    autoComplete="off"
                    onFinish={handleSearch}
                    form={form} >
                    <p className='filter-option-title'>Filter Options</p>
                    <Row gutter={16} className='filters-row'>
                        <Col sm={24} md={24} lg={24} xl={24} xxl={24}>
                            <Form.Item
                                className=''
                                label="Email"
                                name="email"
                                rules={[
                                    {
                                        validator(_, emailValue) {
                                            const emailRegex = /^[\w\+-]+(?:\.[\w\+-]+)*@(?:[\w-]+\.)*\w[\w-]{0,66}\.[a-z]{2,200}(?:\.[a-z]{2})?$/;
                                            if (emailValue && !emailRegex.test(emailValue)) {
                                                return Promise.reject('Invalid email');
                                            } else {
                                                return Promise.resolve();
                                            }
                                        }
                                    },
                                ]}
                            >
                                <Input placeholder='Enter email'
                                    onChange={handleChange} />
                            </Form.Item></Col>
                        <Col sm={24} md={24} lg={24} xl={24} xxl={24}>
                            <Form.Item
                                className=''
                                label="Card Number"
                                name="cardNumber"
                                rules={[
                                    {
                                        validator(_, cardNumber) {
                                            if (Number(cardNumber) || !cardNumber) {
                                                return Promise.resolve();
                                            } else if (!Number(cardNumber)) {
                                                return Promise.reject("Only numbers allowed");
                                            }
                                        }
                                    },
                                ]}
                            >
                                <Input placeholder='Enter card number' maxLength={16} />
                            </Form.Item>
                        </Col>
                        <Col sm={24} md={24} lg={24} xl={24} xxl={24}>
                            <Form.Item className='' label="Status" name="opeationStatus">
                                <Select
                                    className=""
                                    placeholder={`Select status`}
                                >
                                    {props?.opeationLu?.map((item) => (
                                        <Option value={item?.name} key={item?.name}>{item?.name}</Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col sm={24} md={24} lg={24} xl={24} xxl={24}>
                            <Form.Item label="Select date" name="dateRange">
                                <RangePicker format="DD-MM-YYYY" /></Form.Item>
                        </Col>
                    </Row>
                    <div className='mt-2 md:flex justify-end gap-2 space-y-2 md:space-y-0'>
                        <Button className='cancel-btn' onClick={clearRecords} key="back">Clear</Button>
                        <Button className='primary-btn' type="primary" htmlType="submit">Search</Button>
                    </div>
                </Form>
            ,
            key: '1',
        },
    ];
    const handleToolBarActions = (action) => {
        if (action === 'exportexcel') {
            props?.handleExcelExport();
        }
    };
    
    const onActionClick = useCallback((key) => {
        handleToolBarActions(key)
    }, [handleToolBarActions])
    return (
        <div className='flex gap-2 justify-end items-center mb-3 mt-3'>
            <ActionsComponent serviceName={"CardsManageService.CardOperations"} onActionClick={onActionClick} />
            <Dropdown
                overlayClassName='filterdropdown-overlay'
                className='filter-dropdown'
                menu={{
                    items,
                    onClick: handleMenuClick,
                }}
                onOpenChange={handleOpenChange}
                open={open}
                trigger={'click'}
            >
                <a onClick={(e) => e.preventDefault()} className=''>
                    <Tooltip title='Filter'>   <span className='icon filter-icon-dropdown'></span></Tooltip>
                </a>
            </Dropdown>
            <GridLayout/>
        </div>

    )
}
export default Filters;